import { createAction, props } from '@ngrx/store';
import { OrganizationChannel, ConfiguredChannel, DistributionList, Template, EverbridgeTemplate } from './communications.model';
import { QueryParams, QueryResult } from '../../../core/store/models/query.model';
import { FilterGroup } from 'src/app/modules/core/store/models';
import { Document } from 'src/app/modules/core/store/models/document.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

//
// OrganizationChannel actions
//
export const getOrganizationChannelsFromApi = createAction('[Channel/API] Get Organization Channels');
export const getOrganizationChannelsFromApiComplete = createAction(
  '[Channel/API] Get Organization Channels Complete',
  props<{ data: QueryResult<OrganizationChannel> }>()
);
export const newTopoEmailChannel = createAction('[Channel/Page] New Topo Email Channel', props<{ channel: OrganizationChannel }>());
export const newSendGridEmailChannel = createAction('[Channel/Page] New SendGrid Email Channel', props<{ channel: OrganizationChannel }>());
export const newTwilioChannel = createAction('[Channel/Page] New Twilio Channel', props<{ channel: OrganizationChannel }>());
export const newSlackChannel = createAction('[Channel/Page] New Slack Channel', props<{ channel: OrganizationChannel }>());
export const newTeamsChannel = createAction('[Channel/Page] New Teams Channel', props<{ channel: OrganizationChannel }>());
export const newRegroupChannel = createAction('[Channel/Page] New Regroup Channel', props<{ channel: OrganizationChannel }>());
export const newOnSolveChannel = createAction('[Channel/Page] New OnSolve Channel', props<{ channel: OrganizationChannel }>());
export const newAlertMediaChannel = createAction('[Channel/Page] New AlertMedia Channel', props<{ channel: OrganizationChannel }>());
export const newEverbridgeChannel = createAction('[Channel/Page] New Everbridge Channel', props<{ channel: OrganizationChannel }>());

//
// ConfiguredChannel actions
//
export const getConfiguredChannelsFromApi = createAction('[Channel/API] Get Configured Channels', props<{ queryParams: QueryParams }>());
export const getConfiguredChannelsFromApiComplete = createAction(
  '[Channel/API] Get Configured Channels Complete',
  props<{ data: QueryResult<ConfiguredChannel> }>()
);
export const saveConfiguredChannelToApi = createAction('[Channel/API] Save Configured Channel', props<{ channel: ConfiguredChannel }>());
export const saveConfiguredChannelToApiComplete = createAction(
  '[Channel/API] Save Configured Channel Complete',
  props<{ channelUId: string }>()
);
export const saveAndConnectToSlack = createAction('[Channel/API] Save and Connect to Slack', props<{ channel: ConfiguredChannel }>());
export const updateSelectedConfiguredChannel = createAction(
  '[Channel/API] Update Configured Channel',
  props<{ channel: ConfiguredChannel }>()
);
export const connectToSlack = createAction('[Channel/API] Connect to Slack', props<{ channel: ConfiguredChannel }>());
export const deleteConfiguredChannelApi = createAction('[Channel/API] Delete Configured Channel', props<{ channel: ConfiguredChannel }>());
export const deleteConfiguredChannelApiComplete = createAction('[Channel/API] Delete Configured Channel Complete');
export const displayChannelError = createAction('[Channel/Page] Display Error', props<{ err: any }>());
export const closeConfiguredChannelEdit = createAction('[Channel/Page] Close Configured Channel Edit');
export const editTopoEmailChannel = createAction('[Channel/Page] Edit Topo Email Channel', props<{ channel: ConfiguredChannel }>());
export const editSendGridEmailChannel = createAction('[Channel/Page] Edit SendGrid Email Channel', props<{ channel: ConfiguredChannel }>());
export const editEverbridgeChannel = createAction('[Channel/Page] Edit Everbridge Channel', props<{ channel: ConfiguredChannel }>());
export const editSlackChannel = createAction('[Channel/Page] Edit Slack Channel', props<{ channel: ConfiguredChannel }>());
export const editMicrosoftTeamsChannel = createAction('[Channel/Page] Edit Microsoft Teams Channel', props<{ channel: ConfiguredChannel }>());
export const setChannelToDelete = createAction('[Channel/Page] Set Channel to Delete', props<{ channel: ConfiguredChannel }>());
export const clearChannelToDelete = createAction('[Channel/Page] Clear Channel to Delete');
export const startGetSlackChannels = createAction('[Channel/Page] Start Get Slack Channels');
export const getSlackChannelsForConfiguredChannelFromApi = createAction(
  '[Channel/API] Get Slack Channels For ConfiguredChannel',
  props<{ channel: ConfiguredChannel }>()
);
export const getSlackChannelsForConfiguredChannelFromApiComplete = createAction(
  '[Channel/API] Get Slack Channels For ConfiguredChannel Complete',
  props<{ channels: any[] }>()
);
export const editTwilioChannel = createAction('[Channel/Page] Edit Twilio Channel', props<{ channel: ConfiguredChannel }>());
export const disconnectFromSlackWithApi = createAction(
  '[Channel/API] Disconnect Channel From Slack',
  props<{ channel: ConfiguredChannel }>()
);
export const disconnectFromSlackWithApiComplete = createAction(
  '[Channel/API] Disconnect Channel From Slack Complete',
  props<{ channel: ConfiguredChannel }>()
);
export const clearSelectedConfiguredChannel = createAction('[Channel/Page] Clear Selected Configured Channel');

//
// Distribution Lists
//
export const getDistributionListsFromApi = createAction(
  '[DistributionList/API] Get Distribution Lists',
  props<{ queryParams: QueryParams }>()
);
export const getDistributionListsFromApiComplete = createAction(
  '[DistributionList/API] Get Distribution Lists Complete',
  props<{ data: QueryResult<DistributionList> }>()
);
export const displayDistributionListError = createAction('[DistributionList/Page] Display Error', props<{ err: any }>());
export const newDistributionList = createAction('[DistributionList/Page] New Distribution List');
export const newDistributionListComplete = createAction(
  '[DistributionList/Page] New Distribution List Complete',
  props<{ distributionList: DistributionList }>()
);
export const cancelNewDistributionList = createAction('[DistributionList/Page] Cancel New Distribution List');
export const editDistributionList = createAction(
  '[DistributionList/Page] Edit Distribution List',
  props<{ distributionList: DistributionList }>()
);
export const cancelEditDistributionList = createAction('[DistributionList/Page] Cancel Edit Distribution List');
export const cancelEditDistributionListComplete = createAction('[DistributionList/Page] Cancel Edit Distribution List Complete');
export const editDistributionListComplete = createAction(
  '[DistributionList/Page] Edit Distribution List Complete',
  props<{ distributionList: DistributionList }>()
);
export const setDistributionListToDelete = createAction(
  '[DistributionList/Page] Set Distribution List To Delete',
  props<{ distributionList: DistributionList }>()
);
export const clearDistributionListToDelete = createAction('[DistributionList/Page] Clear Distribution List To Delete');
export const deleteDistributionListApi = createAction(
  '[DistributionList/API] Delete Distribution List Api',
  props<{ distributionList: DistributionList }>()
);
export const deleteDistributionListApiComplete = createAction('[DistributionList/API] Delete Distribution List Api Complete');
export const saveDistributionListToApi = createAction(
  '[DistributionList/API] Save Distribution List to Api',
  props<{ distributionList: DistributionList }>()
);
export const saveDistributionListToApiComplete = createAction(
  '[DistributionList/API] Save Distribution List to Api Complete',
  props<{ distributionList: DistributionList }>()
);
export const getDocumentsWithFilterFromApi = createAction(
  '[DistributionList/API] Get Documents With Filter',
  props<{ datasetUId: string; queryParams: QueryParams; filter: FilterGroup }>()
);
export const getDocumentsWithFilterFromApiComplete = createAction(
  '[DistributionList/API] Get Documents With Filter Complete',
  props<{ results: QueryResult<Document> }>()
);
export const saveDocument = createAction(
  '[DistributionList/Page] Save Document',
  props<{ document: Document; dataset: Dataset; filter: FilterGroup;  isNewDocument: boolean }>()
);

//
// Distribution Lists
//
export const getDatasetFromApi = createAction('[CommunicationCenter/API] Get Dataset from API', props<{ datasetUId: string }>());
export const getDatasetFromApiComplete = createAction(
  '[CommunicationCenter/API] Get Dataset from API Complete',
  props<{ dataset: Dataset }>()
);

//
// Distribution Lists
//
export const getTemplatesFromApi = createAction('[Templates/API] Get Templates', props<{ queryParams: QueryParams }>());
export const getTemplatesFromApiComplete = createAction('[Templates/API] Get Templates Complete', props<{ data: QueryResult<Template> }>());
export const getEverbridgeTemplatesFromApi = createAction('[Templates/API] Get Everbridge Templates', props<{ channel: ConfiguredChannel }>());
export const getEverbridgeTemplatesFromApiComplete = createAction('[Templates/API] Get Everbridge Templates Complete', props<{ templates: EverbridgeTemplate[] }>());


export const newTemplate = createAction('[Template/Page] New Template');
export const newTemplateComplete = createAction('[Template/Page] New Template Complete', props<{ template: Template }>());
export const cancelNewTemplate = createAction('[Template/Page] Cancel New Template');
export const editTemplate = createAction('[Template/Page] Edit Template', props<{ template: Template }>());
export const cancelEditTemplate = createAction('[Template/Page] Cancel Edit Template');
export const cancelEditTemplateComplete = createAction('[Template/Page] Cancel Edit Template Complete');
export const editTemplateComplete = createAction('[Template/Page] Edit Template Complete', props<{ template: Template }>());
export const setTemplateToDelete = createAction('[Template/Page] Set Template To Delete', props<{ template: Template }>());
export const clearTemplateToDelete = createAction('[Template/Page] Clear Template To Delete');
export const deleteTemplateApi = createAction('[Template/API] Delete Template Api', props<{ template: Template }>());
export const deleteTemplateApiComplete = createAction('[Template/API] Delete Template Api Complete');
export const saveTemplateToApi = createAction(
  '[Template/API] Save Template List to Api',
  props<{ template: Template; skipNavigation?: boolean }>()
);
export const saveTemplateToApiComplete = createAction('[Template/API] Save Template to Api Complete', props<{ template: Template }>());
export const setTemplateToCopy = createAction('[Template/Page] Set Template To Copy', props<{ template: Template }>());
export const clearTemplateToCopy = createAction('[Template/Page] Clear Template To Copy');
export const copyTemplate = createAction(
  '[Template/API] Copy Template',
  props<{ template: Template; }>()
);
